<template>
    <Row class="store-item">
        <i-col :lg="8" :md="8" v-for="(item,index) in store" class="store-list" :class="{'clear':index === 3}" :key="index">
            <h3>{{item.name}}</h3>
            <p>{{item.address}}</p>
            <p>{{item.phone}}</p>
            <p class="more">
                <router-link :to="{name:'Shop',query:{id:item.id}}" class="text-primary">{{$t('search_store_more')}} &gt;</router-link>
            </p>
        </i-col>
    </Row>
</template>
<script>
    import Signature from '../../../lib/Signature'

    export default {
        name: 'storeItem',
        data () {
            return {
                store: []
            }
        },
        methods: {
            fetchData () {
                let data = {}
                const module = 'index/search/search'
                data.sub_time = Signature.timestamp()
                data.user_id = this.Local.getUserId()
                data.content = this.$route.query.q
                data.token = this.Local.getUserToken()
                data.sign = Signature.create(module, data.sub_time)
                data.lang = this.$i18n.locale
                this.$http.get(process.env.BASEURL + module, {params: data}).then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        console.log(resp.data)
                        this.store = resp.data.data.store_list
                    }
                }.bind(this))
            }
        },
        watch: {
            '$route': function (to, from) {
                this.fetchData()
            }
        },
        created () {
            this.fetchData()
        }
    }

</script>
<style scoped lang="scss">
    @import "../../../scss/common";

    .store-item {
        font-size: 16px;
        margin-bottom: 15px;
        h3 {
            font-size: 24px;
            color: #1F2D3D;
            font-weight: 500;
            line-height: 2;
        }
        p {
            font-size: 18px;
            &.more {
                margin: 10px 0;
            }
        }
        .clear{
            clear: both;
        }
        .store-list{
            padding: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// StoreItem.vue?ad73548c